import { createRouter, createWebHistory } from "vue-router"
import store from "../store";

const employeeNotPermitAccess: string[] = [];
const adminPaths = ["/companyList", "/affiliateApplication"].map((a) => String(a).toLowerCase());

//const Login = () => import("../views/Login.vue")
//const Login = () => import("@/views/Login.vue")

const routes = [
  // {
  //   path: "/api/*" // Ignore or pass on to server
  // },
  {
    path: "/dashboard",
    meta: {
      layout: "",
      requiresAuth: false,
      unlocked: false
    },
    redirect: "/"
  },
  {
    path: "/",
    name: "Dashboard",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/Dashboard.vue")
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    //component: Login
    component: () => import("../views/Login.vue")
  },
  {
    path: "/signup",
    name: "Signup",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    component: () => import("../views/Signup.vue")
  },
  {
    path: "/affiliateSignUp",
    name: "AffiliateSignUp",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    component: () => import("../views/AffiliateSignUp.vue")
  },
  {
    path: "/xeroSignIn",
    name: "XeroSignIn",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    component: () => import("../views/XeroSignIn.vue")
  },
  {
    path: "/xeroAppStoreSignIn",
    name: "XeroAppStoreSignIn",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    component: () => import("../views/XeroAppStoreSignIn.vue")
  },
  {
    path: "/resetPassword",
    name: "RequestRecovery",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    component: () => import("../views/RequestRecovery.vue")
  },
  {
    path: "/users",
    name: "Users",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/Users.vue")
  },
  {
    path: "/finalise",
    name: "FinaliseAccount",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    component: () => import("../views/FinaliseAccount.vue")
  },
  {
    path: "/companyList",
    name: "CompanyList",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: true
    },
    component: () => import("../views/CompanyList.vue")
  },
  {
    path: "/affiliateApplication",
    name: "AffiliateApplication",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: true
    },
    component: () => import("../views/AffiliateApplication.vue")
  },
  {
    path: "/signupBusinessInfo",
    name: "SignupBusinessInfo",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: true,
      unlocked: true
    },
    component: () => import("../views/SignUpBusinessInfo.vue")
  },
  {
    path: "/invalidLink",
    name: "InvalidLink",
    meta: {
      layout: "DialogBackdrop",
      requiresAuth: false,
      unlocked: true
    },
    component: () => import("../views/InvalidLinkPage.vue")
  },
  {
    path: "/profitLoss",
    name: "ProfitLoss",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/ProfitLoss.vue")
  },
  {
    path: "/incomeDrivers",
    name: "IncomeDrivers",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/IncomeDrivers.vue")
  },
  {
    path: "/expenseDrivers",
    name: "ExpenseDrivers",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/ExpenseDrivers.vue")
  },
  {
    path: "/whatIf",
    name: "WhatIf",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/WhatIf.vue")
  },
  {
    path: "/whatIfDetail",
    name: "WhatIfDetail",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/WhatIfDetail.vue")
  },
  {
    path: "/cashSummary",
    name: "CashSummary",
    meta: {
      layout: "MainLayout",
      requiresAuth: true,
      unlocked: false
    },
    component: () => import("../views/CashSummary.vue")
  },
  // ,
  // {
  //   path: "/:catchAll(.*)",
  //   redirect: "/dashboard" // should be 404 later
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

//Avoid display console issue when go to same route
// const originalPush = VueRouter.prototype.push as unknown as Promise<Route>
// VueRouter.prototype.push = function push (location: RawLocation) {
//   return (originalPush as any).call(this, location).catch((err: Error) => err)
// }

router.beforeEach(async (to, from, next) => {
  store.commit("setOnRouterChange", true);
  await store.dispatch("initialise");
  if (store.getters.isLoggedIn && !store.getters.isSubDetailsLoaded) {
    try {
      await store.dispatch("updateSubscriptionState");
    }
    catch (ex) {
      next(String("/login").toLowerCase());
      throw new Error("Login expired, you have been logged out");
    }
  }
  const subLocked = store.getters.isSubscriptionLocked;
  const urlCode = new URL(location.href).searchParams.get("code");
  const openSub = new URL(location.href).searchParams.get("openSub");
  const r = routes.find((a) => a.name === to.name);
  
  const isLoggedIn = store.getters.isLoggedIn && store.getters.userID;
  const isLoggedInAsEmployee = store.getters.isLoggedIn && store.getters.userID && !store.getters.isOwner && !store.getters.isAdmin;
  const isLoggedInAsAdmin = store.getters.isLoggedIn && store.getters.userID && store.getters.isAdmin;
  const isImpersonatingUser = store.getters.isImpersonatingUser;

  const hasBusiness = store.getters.businessID;
  const initialSetUpCompleted = store.getters.initialSetUpCompleted;
  const ownerOnlyScreen = employeeNotPermitAccess.some((route) => {
    if (String(route).toLowerCase() === String(to.path).toLowerCase()) {
      return true;
    }
  });
  //unregister router return to old place
  if (r) {
    if (store.getters.appDataReady) {
      //check auth request
      if (to?.meta?.requiresAuth) {
        if (isLoggedIn) {
          const needsBusinessSignup = String(to.path).toLowerCase() !== String("/signupBusinessInfo").toLowerCase() && !isLoggedInAsAdmin && !initialSetUpCompleted;
          const redirectFromSignup = String(to.path).toLowerCase() === String("/signupBusinessInfo").toLowerCase() && hasBusiness && initialSetUpCompleted;
          const accessingAdminPage = adminPaths.includes(String(to.path).toLowerCase());

          // restrict access to whatIf and cashSummary if not on current period
          if ((String(to.path).toLowerCase() == String("/whatIf").toLowerCase() || String(to.path).toLowerCase() == String("/cashSummary").toLowerCase()) &&
              store.getters.selectedPeriod.toLowerCase() !== "Current".toLowerCase()) {
            next(String("/dashboard").toLowerCase());
          }

          if (subLocked && !isLoggedInAsAdmin && String(to.path).toLowerCase() !== String("/signupBusinessInfo").toLowerCase() && String(to.path).toLowerCase() !== String("/").toLowerCase() && String(to.path).toLowerCase() !== String("/dashBoard").toLowerCase()) {
            next(String("/dashboard").toLowerCase());
          }

          if (needsBusinessSignup && urlCode) {
            next(false);
            return;
          }

          // TODO: Ensure as a part of 97992, that we add any additional sign-up steps as needed
          if (needsBusinessSignup && !urlCode) {
            next(String("/signupBusinessInfo").toLowerCase());
          }
          // Prevent non admins, or admins impersonating an account from accessing these pages (must log out first)
          else if (accessingAdminPage && (!isLoggedInAsAdmin || isImpersonatingUser)) {
            store.commit("setOnRouterChange", false);
            next(from.path);
          }
          //admin user can not go any where expected /companyList and /affiliateApplication
          else if (!accessingAdminPage && isLoggedInAsAdmin && !isImpersonatingUser) {
            const currentPath = String(to.path).toLowerCase();
            
            if (!adminPaths.includes(currentPath)) {
              next(String("/companylist").toLowerCase());
            } else {
              next();
            }
          }
          else if (ownerOnlyScreen && isLoggedInAsEmployee) {
            next(from.path);
          }
          else if (redirectFromSignup) {
            next(from.path);
          }
          else {
            next();
          }
        }
        else {
          if (urlCode) {
            next()
          }
          else if (openSub && openSub === "1") {
            next(String("/login").toLowerCase() + "?openSub=1");
          }
          else {
            next(String("/login").toLowerCase());
          }
        }
      }
      else {
        //only access to login / sign up / reset password without log in any account
        if (
          (String(to.path).toLowerCase() === String("/login").toLowerCase() ||
          String(to.path).toLowerCase() === String("/signup").toLowerCase() ||
          String(to.path).toLowerCase() === String("/affiliateSignUp").toLowerCase() ||
          String(to.path).toLowerCase() === String("/resetPassword").toLowerCase())
          && store.getters.isLoggedIn && store.getters.userID)
        {
          next(from.path);
        }
        else {
          next();
        }
      }
    }
    else {
      next();
    }
  }
  else {
    next(from.path);
  }
});

router.afterEach((to, from) => {
  store.commit("setOnRouterChange", false);
});

export default router
